import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { ExcelService } from 'src/app/service/excel.service';

export interface StandardElement {
  name: string;
  dueAmount: string;
}

@Component({
  selector: 'app-due-list',
  templateUrl: './due-list.component.html',
  styleUrls: ['./due-list.component.css']
})
export class DueListComponent implements OnInit {

  displayedColumns: string[] = ['name','date','dueAmount','cd'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  tblLoading=false;
  itemTotal=0;
  srNo=0;

  constructor(private api:ApiService,private route:ActivatedRoute,private excelService:ExcelService) { }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.dueList[0].total);
      this.dataSource.data=data.dueList[0].data;
    },(error)=>{

    });
  }

  counter(i)
  {
    let num=i+1;
    return this.srNo+num;
  }

  print()
  {
    window.print();
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    this.srNo=start;
    let postData={start:start,length:event.pageSize};
    this.api.get("donarDueList?start="+start+"&length="+event.pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }

  exportAsXLSX():void {
    this.api.get("donarDueList?&export=excel").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.excelService.exportAsExcelFile(data.data, 'sample');
    },(error)=>{

    });
    
 }

 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
    url="donarDueList?&orderBy=dueDate_desc&start=0&length=10&name="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
     url="donarDueList?&orderBy=dueDate_desc&start=0&length=10&";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
  },(error)=>{

  });

}

}